import {createRepo} from '../services/repo';
const samplesRepo = createRepo({
  modelName: 'sample',
  plural: 'samples',
  isGlobal: true
});

const {SAMPLES_LOADING_SUCCESS} = samplesRepo.actions;
const {handleSamplesLoading} = samplesRepo.reducers;

const initialState = samplesRepo.getInitialState();

export default function(state = initialState, action) {
  switch (action.type) {
    case SAMPLES_LOADING_SUCCESS:
      return handleSamplesLoading(state, action);
    default:
      return state;
  }
}

/* Selectors */

export const {getSamples} = samplesRepo.selectors;
